import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pathpointinfo"
    }}>{`PathPointInfo`}</h1>
    <p>{`Used to create a `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathpoint/"
      }}>{`PathPoint`}</a>{`, which represents the anchor and control-handle endpoints for a path segment.
Each point (the anchor point, left-direction point, and right-direction point) is an array containing X and Y
position coordinates.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Use the JavaScript `}<inlineCode parentName="p">{`new`}</inlineCode>{` operator to create these objects, and store them in the `}<a parentName="p" {...{
            "href": "/photoshop/uxp/ps_reference/classes/subpathinfo/#entiresubpath"
          }}>{`SubPathInfo.entireSubPath`}</a>{`
property before using that object to create a path item with `}<a parentName="p" {...{
            "href": "/photoshop/uxp/ps_reference/classes/pathitems/#add"
          }}>{`PathItems.add`}</a>{`()`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The resulting `}<a parentName="p" {...{
            "href": "/photoshop/uxp/ps_reference/classes/subpathitem/"
          }}>{`SubPathItem`}</a>{` object contains the resulting `}<a parentName="p" {...{
            "href": "/photoshop/uxp/ps_reference/classes/pathpoint/"
          }}>{`PathPoint`}</a>{` objects. Use the `}<a parentName="p" {...{
            "href": "/photoshop/uxp/ps_reference/classes/pathpoint/"
          }}>{`PathPoint`}</a>{` object
to retrieve information about the points that describe existing path segments. The properties are read-only.`}</p>
      </li>
    </ul>
    <p>{`For paths that are straight segments (not curved), the coordinates of all three points are the same. For curved
segments, the coordinates are different. The difference between the anchor point and the left or right
direction points determines the arc of the curve. Use the left direction point to bend the curve "outward" or
make it convex; or use the right direction point to bend the curve "inward" or make it concave.`}</p>
    <h2 {...{
      "id": "pathpointinfo-sample-script"
    }}>{`PathPointInfo sample script`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`     function drawLine(doc: Document, start: number[], stop: number[]) {
         const startPoint = new PathPointInfo();
         startPoint.anchor = start;
         startPoint.leftDirection = start;
         startPoint.rightDirection = start;
         startPoint.kind = Constants.PointKind.CORNERPOINT;

         const stopPoint = new PathPointInfo();
         stopPoint.anchor = stop;
         stopPoint.leftDirection = stop;
         stopPoint.rightDirection = stop;
         stopPoint.kind = Constants.PointKind.CORNERPOINT;

         const spi = new SubPathInfo();
         spi.closed = false;
         spi.operation = Constants.ShapeOperation.SHAPEXOR;
         spi.entireSubPath = [startPoint, stopPoint];

         const line = doc.pathItems.add("Line", [spi]);
         line.strokePath(Constants.ToolType.PENCIL);
         line.remove();
     }

     drawLine(app.activeDocument, [100,100], [200,200]);
`}</code></pre>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "anchor"
    }}>{`anchor`}</h3>
    <p>{`• `}<strong parentName="p">{`anchor`}</strong>{`: `}<em parentName="p">{`number`}</em>{`[]`}</p>
    <p>{`The X and Y coordinates of the anchor point of the curve.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "kind"
    }}>{`kind`}</h3>
    <p>{`• `}<strong parentName="p">{`kind`}</strong>{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/modules/constants/#pointkind"
      }}><em parentName="a">{`PointKind`}</em></a></p>
    <p>{`The role (corner or smooth) this point plays in the containing path segment.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "leftdirection"
    }}>{`leftDirection`}</h3>
    <p>{`• `}<strong parentName="p">{`leftDirection`}</strong>{`: `}<em parentName="p">{`number`}</em>{`[]`}</p>
    <p>{`The location of the left-direction endpoint('in' position).`}</p>
    <hr></hr>
    <h3 {...{
      "id": "rightdirection"
    }}>{`rightDirection`}</h3>
    <p>{`• `}<strong parentName="p">{`rightDirection`}</strong>{`: `}<em parentName="p">{`number`}</em>{`[]`}</p>
    <p>{`The location of the right-direction endpoint('out' position).`}</p>
    <hr></hr>
    <h3 {...{
      "id": "typename"
    }}>{`typename`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{` `}<strong parentName="p">{`typename`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <p>{`The class name of the referenced object`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      